module.exports = __webpack_public_path__ + "96bc9d7e27d077372cc0bc9524c500e6.png";